import { render, staticRenderFns } from "./netUrlPic.vue?vue&type=template&id=12b8dbbe&scoped=true&"
import script from "./netUrlPic.vue?vue&type=script&lang=js&"
export * from "./netUrlPic.vue?vue&type=script&lang=js&"
import style0 from "./netUrlPic.vue?vue&type=style&index=0&id=12b8dbbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b8dbbe",
  null
  
)

export default component.exports